import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  Typography,
  Checkbox,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import PDFViewer from "pdf-viewer-reactjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../Components/CustomInput";
import DateComponent from "../../../Components/FormGenerator/datepicker_component";
import CircularIndeterminate from "../../../Components/Loader";
import { showSnackbar } from "../../../Components/Snackbar/SnackbarActions";
import AdminPartnerClient from "../../../Service/Admin/partner_services";
import DataClient from "../../../Service/general_data_service";
import Header from "./header";
import { GLOBAL_STEPPER_DATA } from "../../../Redux/actions";
const useStyles = makeStyles((theme) => ({
  labelText: {
    color: "#4D4F5C",
    fontSize: "16px",
    lineHeight: "22px",
  },
}));

function WorkingWithAcuity(props: any) {
  const classes = useStyles();
  const data = {
    acceptance: false,
    date: "",
    first_name: "",
    last_name: "",
  };
  const global_data = useSelector((state: any) => state.stepperReducer);
  const [pdfData, setPdfData]: any = useState({});
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(data);
  const [partnerNDAFlag, setPartnerNDAFlag] = useState(false);
  const dispatch = useDispatch();
  //@ts-ignore
  const globaluserData = useSelector((state) => state.commonReducer);
  const role = globaluserData?.role;
  // let role = sessionStorage.getItem("role");

  const setInputState = (inputStateValue: any, inputId: any) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    setWWAFormError((prev) => {
      return { ...prev, [inputId]: false };
    });
  };

  const [WWAFormError, setWWAFormError] = useState({
    acceptance: false,
    date: "",
    first_name: "",
    last_name: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    console.log(props.profileId);
    setLoading(true);
    AdminPartnerClient.wwa_get({
      partner_profile_id: global_data.partner_profile,
    })
      .then((response: any) => {
        setPdfData(response);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });

    DataClient.getData(
      "partner_wwas/fetch_wwa?partner_profile_id=" + global_data.partner_profile
    )
      .then((response: any) => {
        console.log(response);
        response.partner_wwa && setUserData(response.partner_wwa);
        setPartnerNDAFlag(response.partner_wwa ? true : false);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        dispatch(showSnackbar("error", [error.errors]));
      });
  }, []);

  const onSubmit = () => {
    AdminPartnerClient.ndA_wwa_send({
      partner_profile_id: global_data.partner_profile,
      nda_submitted: false,
      wwa_submitted: true,
    })
      .then((response: any) => {
        // props.parentSetProfileId(response.data.id,response.data.attributes.acuity_people_profile_id);
        dispatch(showSnackbar("Success", ["Wwa submit successfully"]));

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dispatch(showSnackbar("error", [error.errors]));
      });

    props.parentHandleNext(props.activeIndex + 1);
    // AdminPartnerClient.BasicInfo(userData).then((response: any) => {
    //     props.parentSetProfileId(response.data.id,response.data.attributes.acuity_people_profile_id);
    // }).catch(error => dispatch(showSnackbar("error",["Some error occured!"])));

    props.parentHandleNext(props.activeIndex + 1);
  };

  const saveToAcuity = () => {
    let blockRequest = false;

    if (userData.first_name === "") {
      setWWAFormError((prev: any) => {
        return { ...prev, first_name: true };
      });
      blockRequest = true;
    }
    if (userData.date === null || userData.date === "") {
      setWWAFormError((prev: any) => {
        return { ...prev, date: true };
      });
      blockRequest = true;
    }
    if (userData.last_name === "") {
      setWWAFormError((prev: any) => {
        return { ...prev, last_name: true };
      });
      blockRequest = true;
    }
    if (!userData.acceptance) {
      setWWAFormError((prev: any) => {
        return { ...prev, acceptance: true };
      });
      blockRequest = true;
    }

    if (blockRequest) {
      console.log(userData, "userdata", WWAFormError);
      return;
    } else {
      setLoading(true);

      if (partnerNDAFlag) {
        DataClient.update(
          { partner_profile_id: global_data.partner_profile, ...userData },
          "partner_wwas/update_wwa"
        )
          .then((response: any) => {
            console.log("partner_wwa.id", response);
            if (response.partner_wwa) {
              dispatch(showSnackbar("Success", ["Wwa submit successfully"]));
              dispatch({
                type: GLOBAL_STEPPER_DATA,
                payload: { partner_wwa_id: response.partner_wwa.id },
              });

              setLoading(false);
            }
            dispatch(
              showSnackbar("Success", ["Data updated to acuity successfully"])
            );
            setLoading(false);
            onSubmit();
          })
          .catch((error) => {
            setLoading(false);
            dispatch(showSnackbar("error", [error.errors]));
          });
      } else {
        DataClient.create(
          { partner_profile_id: global_data.partner_profile, ...userData },
          "partner_wwas"
        )
          .then((response: any) => {
            if (response.partner_wwa) {
              dispatch(showSnackbar("Success", ["Wwa submit successfully"]));
              dispatch({
                type: GLOBAL_STEPPER_DATA,
                payload: { partner_wwa_id: response.partner_wwa.id },
              });

              setLoading(false);
            }
            // dispatch(showSnackbar("Success", ["Data submit to acuity successfully"]))
            setLoading(false);
            onSubmit();
          })
          .catch((error) => {
            setLoading(false);
            dispatch(showSnackbar("error", [error.errors]));
          });
      }
    }
  };

  const onBack = () => {
    props.parentHandleNext(props.activeIndex - 1);
  };

  return (
    <>
      <iframe
        title="file"
        style={{ width: "100%", height: "calc(100vh - 350px)" }}
        src={pdfData.url}
      />
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ padding: 30, paddingBottom: 0 }}
        spacing={2}
      >
        <Grid item xs={4}>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 30 }}
          >
            <Grid item xs={4}>
              <Typography variant="h2">First name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id="first_name"
                variant="outlined"
                placeholder="First name"
                parentcall={setInputState}
                value={userData.first_name}
                error={WWAFormError.first_name}
                helperText={
                  WWAFormError.first_name
                    ? "Please enter a valid first name"
                    : ""
                }
              />
            </Grid>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={4}>
              <Typography variant="h2">Last name</Typography>
            </Grid>
            <Grid item xs={8}>
              <CustomInput
                id="last_name"
                variant="outlined"
                placeholder="Last name"
                parentcall={setInputState}
                value={userData.last_name}
                error={WWAFormError.last_name}
                helperText={
                  WWAFormError.last_name ? "Please enter a valid last name" : ""
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={4}>
          <Grid
            container
            direction="row"
            alignItems="center"
            style={{ marginBottom: 10 }}
          >
            <Grid item xs={4}>
              <Typography style={{ marginTop: -20 }} variant="h2">
                Date
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <DateComponent
                key={"011"}
                componentObject={{
                  componentType: "datePicker",
                  required: true,
                  label: "",
                  name: "date",
                  placeholder: "DD/MM/YYYY",
                  indexKey: "0-1",
                  index: "date",
                  handleChange: setInputState,
                  value: userData.date,
                  error: WWAFormError.date,
                  helperText: WWAFormError.date
                    ? "Please select a valid date"
                    : "",
                }}
              />
            </Grid>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e: any) => {
                      setInputState(e.target.checked, "acceptance");
                      if (e.target.checked) {
                        setWWAFormError((prev) => {
                          return { ...prev, acceptance: false };
                        });
                      }
                    }}
                    checked={userData.acceptance}
                    name="acceptance"
                    color="primary"
                    style={{ paddingTop: "0px" }}
                  />
                }
                label={
                  <Typography variant="h2">
                    I have read and understand the information contained within
                    this Working with Acuity document
                  </Typography>
                }
              />
              {WWAFormError.acceptance ? (
                <p
                  style={{
                    fontSize: "12px",
                    color: "rgb(244, 67, 54)",
                  }}
                >
                  {" "}
                  * Please read and accept.
                </p>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Header
        isBack={true}
        saveBtnTitle={
          role == "admin" ? "Save and Send WWA" : "Submit to Acuity"
        }
        parentcall={saveToAcuity}
        parentBackCall={onBack}
      />
      {loading && <CircularIndeterminate />}
    </>
  );
}

export default WorkingWithAcuity;
